import { SidebarItem } from '@backstage/core-components';
import { ChatIcon } from '../ui/sidebarIcons';
import { useCanAccessPsAgent } from './useCanAccessPsAgent';

export const PsAgentSidebarItem = () => {
  const canAccess = useCanAccessPsAgent();

  if (canAccess !== true) {
    return null;
  }

  return <SidebarItem icon={ChatIcon} to="agent" text="PS Agent" />;
};
